import { useRef, useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Fragment } from "react/jsx-runtime";
import { SidebarLayoutNew } from "../components/sidebar-layout-new";
import { Field, ErrorMessage,Label } from "../components/fieldset";
import { Heading, Subheading } from "../components/heading";
import { Checkbox, CheckboxField} from '../components/checkbox'
import { Input } from "../components/input";
import { Text } from "../components/text";

import { Button } from "../components/button";
import { Loader } from "../components/loader";
import {
  DocumentPlusIcon,
  EyeIcon,
  PencilSquareIcon,
} from "@heroicons/react/16/solid";
import config from "../config.js";
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { PageInfo } from "../components/page-info";
import { Divider } from "../components/divider";
import { Listbox, ListboxOption } from "../components/listbox-new";
import { Combobox } from "../components/combobox-new2";
import { TitlePermutation } from "../components/TitlePermutation-new2";
import { TitlePermutationEdit } from "../components/TitlePermutationEdit";
import { CategoryTree } from "../components/CategoryTree";
import {
  ErrorNotification,
  SuccessNotification,
} from "../components/notification";
//
export default function AddTestTitle() {
  const [initialData, setInitialData] = useState(null);
  const { actionType, cycleId } = useParams();
  let mode = "add";
  mode = actionType;
  const pageTitle = mode
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
  const breadcrumbs_link = [
    { name: "Title Test", href: "/title-test", current: false },
    { name: `${pageTitle} a Title Test`, href: "#", current: true },
  ];
  const isEditMode = mode === "edit";
  const isViewMode = mode === "view";
  //
  const navigate = useNavigate();
  let page_info = "";
  if (isViewMode) {
    page_info = `This section allows you to view an existing Title Test and explore different title variations.`;
  } else if (isEditMode) {
    page_info = `This section allows you to modify an existing Title Test and try out different title variations.`;
  } else {
    page_info = `This section allows you to create a new Title Test and experiment with different title variations.`;
  }
  //On Focus Process Variables
  const scrollContainerRef = useRef(null);
  const effectRan = useRef(false);
  const inputRefs = useRef({});
  //Define Variables
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [showErrorBox, setShowErrorBox] = useState(false);
  const [brandOptions, setBrandOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [permutations, setPermutations] = useState({});
  const [formData, setFormData] = useState({});
  const [optionsAI, setOptionsAI] = useState([]);
  const batchTypeOpt = [
    { value: "exclude_exists_batch", label: "Exclude Exist Batch Products" },
    { value: "include_all", label: "Include All Products" },
  ];
  const titleDepthOpt = [
    { value: "use_shopping_only", label: "Use data in Google Shopping only" },
    { value: "think_carefully", label: "Think carefully to improve data (uses more tokens)" },
	{ value: "think_deeply", label: "Think deeply to improve data (uses even more tokens)" },
  ]; 
  const impressionsOpt = [
    { value: "all", label: "All products" },
    { value: "0", label: "Zombies" },
    { value: "100", label: "< 100" },
    { value: "1000", label: "< 1000" },
    { value: "5000", label: "< 5000" },
    { value: "10000", label: "< 10,000" },
  ];
  const triggerImpOpt = [
    { value: "", label: "-- Select --" },
    { value: "100", label: "100" },
    { value: "500", label: "500" },
    { value: "1000", label: "1,000" },
    { value: "2000", label: "2,000" },
    { value: "3000", label: "3,000" },
    { value: "5000", label: "5,000" },
  ];
  const triggerDaysOpt = [
    { value: "", label: "-- Select --" },
    { value: "7", label: "7" },
    { value: "15", label: "15" },
    { value: "30", label: "30" },
    { value: "90", label: "90" },

    { value: "180", label: "180" },
  ];
  const skuLimitOpt = [
    { value: "50", label: "50" },
    { value: "100", label: "100" },
    { value: "500", label: "500" },
    { value: "1000", label: "1000" },
    { value: "5000", label: "5000" },
  ];
  const startTypes = [
    { value: "Immediately", label: "Immediately" },
    { value: "Cycle Start After", label: "Cycle Start After" },
  ];

  const cycleObjectiveOpt = [
    { value: "", label: "-- Select --" },
    { value: "CTR", label: "CTR" },
    { value: "CPC", label: "CPC" } 
  ];
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1); // Set tomorrow to 1 day after today

  // Convert to ISO string format (yyyy-mm-dd)
  const isoToday = today.toISOString().split("T")[0];

  useEffect(() => {
    setFormErrors({});
    setSuccessMsg("");
    setShowSuccessBox(false);
    if (!effectRan.current) {
      effectRan.current = true;
      if (cycleId !== "" && cycleId !== undefined) {
        setLoading(true);
        fetch(
          `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=view_cycle&cycle_master_id=${cycleId}`,
          {
            method: "GET",
            credentials: "include",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (
              data.status === "error" &&
              data.errMsg === "Invalid Loign Data"
            ) {
              window.location.href = `/${config.appPath}`;
            } else {
              if (
                data.records &&
                typeof data.records === "object" &&
                Object.keys(data.records).length > 0
              ) {
                setInitialData(data.records);
                setLoading(false);
              } else {
                navigate("/title-test");
              }
            }
          });
      }
      fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_brand`,
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
            window.location.href = `/${config.appPath}`;
          } else {
            const brandsArray = Object.entries(data.brands || {}).map(
              ([value, label]) => ({ value, label })
            );
            setBrandOptions(brandsArray);
          }
        });

      fetch(
        `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=get_instruct`,
        {
          method: "GET",
          credentials: "include",
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "error" && data.errMsg === "Invalid Loign Data") {
            window.location.href = `/${config.appPath}`;
          } else {
            setOptionsAI(data);
          }
        });
    }
    // Reset or set form values
    if (initialData) {
      setFormData({ ...initialData });
      setPermutations(initialData.permutations || {});
    } else {
      setFormData({
        cycle_name: "",
        cycle_objective: "",
        category: "all",
        brand: "all",
        impressions: "all",
        sku_limit: "50",
        impression_count: "",
        days: "",
        start_type: "Immediately",
        custom_date: isoToday,
        fullPath: "All categories",
        batch_type: "exclude_exists_batch",
		qcTest:false,
		title_depth:'use_shopping_only',
      });
      setPermutations({});
    }
  }, [initialData]);

  //
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
	console.log(permutations);
    const url =
      initialData && isEditMode
        ? `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=update_cycle`
        : `${config.apiPath}test-cycle/test_cycle_ui_handler.php?type=add_cycle`;
    const errors = {};
    if (!formData?.cycle_name?.trim()) {
      errors.cycle_name = "Test Name is required.";
    }
    if (!formData?.cycle_objective?.trim()) {
      errors.cycle_objective = "Objective is required.";
    }
    const ruleBlocks = Object.values(permutations || {});

    const invalid =
      ruleBlocks.length === 0 ||
      ruleBlocks.some((rule) => {
        const title = typeof rule?.title === "string" ? rule.title.trim() : "";
        const emphasis =
          typeof rule?.emphasis === "string" ? rule.emphasis.trim() : "";
        const rules = Array.isArray(rule?.rules) ? rule.rules : [];

        const hasValidTitle = !!title;
        const hasValidRules = rules.some(
          (r) => typeof r === "string" && r.trim() && r.trim() !== "custom:"
        );
        const hasValidEmphasis = !!emphasis;

        // INVALID if: no title OR (no valid rules AND no valid emphasis)
        return !hasValidTitle || (!hasValidRules && !hasValidEmphasis);
      });
    // Check for duplicate titles
    const titles = ruleBlocks.map((r) => r.title.trim().toLowerCase());
    const titleSet = new Set(titles);
    const hasDuplicateTitles = titles.length !== titleSet.size;
    if (hasDuplicateTitles) {
      errors.permutations = "Each title in permutations must be unique.";
    }
    if (invalid) {
      errors.permutations =
        "Each title permutation must include a title and at least one Instruction or emphasis.";
    }
    if (!formData?.impression_count?.trim() && !formData?.days?.trim()) {
      errors.trigger = "Either Impression Count or Days must be set.";
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      const firstErrorField = Object.keys(errors)[0];
      const fieldEl = inputRefs.current[firstErrorField];
      fieldEl?.scrollIntoView({ behavior: "smooth", block: "center" });
      fieldEl?.focus();
      return;
    }

    const payload = {
      ...formData,
      permutations: permutations,
    };
    try {
      setLoading(true);
      setSubmitting(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status === "success") {
        scrollContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
        setFormErrors({});
        setSuccessMsg(result.message);
        setShowSuccessBox(true);
        setTimeout(() => {
          setShowSuccessBox(false);
          setSuccessMsg("");
          navigate("/title-test");
        }, 3000);
      } else {
        setErrorMsg(result.errmsg);
        setShowErrorBox(true);
        setTimeout(() => {
          setShowErrorBox(false);
          setErrorMsg("");
        }, 3000);
        setSubmitting(false);
        setLoading(false);
      }
    } catch (error) {
      setErrorMsg("Something went wrong. Please try again.");
      setShowErrorBox(true);
      setTimeout(() => {
        setShowErrorBox(false);
        setErrorMsg("");
      }, 3000);
      scrollContainerRef.current?.scrollTo({ top: 0, behavior: "smooth" });
      setSubmitting(false);
      setLoading(false);
    }
  };
  //
  const handleChange = (e) => {
    const { name, value, fullPath } = e.target;
    const updatedForm = {
      ...formData,
      [name]: value,
      ...(fullPath && { fullPath }),
      ...(name === "start_type" &&
        value !== "Cycle Start After" && { custom_date: isoToday }),
    };
    if (name === "start_type" && value === "Cycle Start After") {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const isoTomorrow = tomorrow.toISOString().split("T")[0]; // yyyy-mm-dd
      updatedForm.custom_date = isoTomorrow;
    }
    setFormData(updatedForm);
    // Clear per-field error
    setFormErrors((prev) => {
      const updatedErrors = { ...prev, [name]: "" };

      // Also clear 'trigger' error if at least one of the two is filled
      if (
        (name === "days" || name === "impression_count") &&
        (updatedForm.days?.trim() || updatedForm.impression_count?.trim())
      ) {
        updatedErrors.trigger = "";
      }
      return updatedErrors;
    });
  };

  const handlePermutationChange = useCallback((val) => {
    setPermutations(val);
    console.log(val);

    setFormErrors((prevErrors) => {
      const ruleBlocks = Object.values(val);
      const invalid = ruleBlocks.some((rule) => {
        const title = typeof rule?.title === "string" ? rule.title.trim() : "";
		const category =
          typeof rule?.category === "string" ? rule.category.trim() : "";
        const emphasis =
          typeof rule?.emphasis === "string" ? rule.emphasis.trim() : "";
        const rules = Array.isArray(rule?.rules) ? rule.rules : [];

        const hasValidTitle = !!title;
        const hasValidEmphasis = !!emphasis;
        const hasValidRules = rules.some(
          (r) => typeof r === "string" && r.trim() && r.trim() !== "custom:"
        );

        // Invalid if: no title OR neither rules nor emphasis present
        return !hasValidTitle || (!hasValidRules && !hasValidEmphasis);
      });

      if (!invalid && prevErrors.permutations) {
        const { permutations, ...rest } = prevErrors;
        return rest;
      }

      return prevErrors;
    });
  }, []);

  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="title-test">
        <SuccessNotification
          showSuccessBox={showSuccessBox}
          successMsg={successMsg}
          setShowSuccessBox={setShowSuccessBox}
        />
        <ErrorNotification
          showErrorBox={showErrorBox}
          errorMsg={errorMsg}
          setShowErrorBox={setShowErrorBox}
        />
        <BreadcrumbsNew pages={breadcrumbs_link} />
        <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
          {isViewMode ? (
            <EyeIcon className="!size-8" />
          ) : isEditMode ? (
            <PencilSquareIcon className="!size-8" />
          ) : (
            <DocumentPlusIcon className="!size-8" />
          )}
          <Heading>{pageTitle} a Title Test</Heading>
        </div>
        <PageInfo info={page_info} />
        <form onSubmit={handleSubmit} className="mx-auto max-w-6xl">
          <Divider className="my-4 mt-2" />
          <section className="space-y-6">
            {/* --- Row 1: Common Title --- */}
            <div className="space-y-1">
              <Subheading>Test</Subheading>
              <Text>Enter your test details below.</Text>
            </div>

            {/* --- Row 2: Two Fields Side by Side --- */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-8 md:ml-12">
              {/* Test Name */}
              <Field ref={(el) => (inputRefs.current["cycle_name"] = el)}>
                <Subheading>Name</Subheading>
                <Input
                  id="cycle_name"
                  name="cycle_name"
                  value={formData.cycle_name}
                  onChange={handleChange}
                  type="text"
                  invalid={!!formErrors.cycle_name}
                  disabled={isViewMode}
                />
                {formErrors.cycle_name && (
                  <ErrorMessage>{formErrors.cycle_name}</ErrorMessage>
                )}
              </Field>

              {/* Test Objective */}
              <Field ref={(el) => (inputRefs.current["cycle_objective"] = el)}>
                <Subheading>Objective</Subheading>
                <Listbox
                  id="cycle_objective"
                  name="cycle_objective"
                  disabled={isViewMode}
                  value={formData.cycle_objective}
                  onChange={(value) =>
                    handleChange({ target: { name: "cycle_objective", value } })
                  }
                  className={`w-full appearance-none rounded-md mb-3 py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 ${
                    formErrors.cycle_objective
                      ? "outline-red-300"
                      : "outline-gray-300"
                  } focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6`}
                >
                  {cycleObjectiveOpt.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>
                {formErrors.cycle_objective && (
                  <ErrorMessage>{formErrors.cycle_objective}</ErrorMessage>
                )}
              </Field>
            </div>
          </section>

          <Divider className="my-4" soft />

          <section className="grid gap-y-8">
            {/* Title Row */}
            <div className="space-y-1">
              <Subheading>Select Products</Subheading>
              <Text>Applied filters for the test title are as follows.</Text>
            </div>

            {/* 3 × 2 Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:ml-0 lg:ml-12">
              {/* Row 1 */}
              <div>
                <Subheading className="mb-2">Category</Subheading>
                <CategoryTree
                  name="category"
                  value={formData.category}
                  fullPath={formData.fullPath}
                  apiUrl={`${config.apiPath}test-cycle/categories.php`}
                  onChange={(value) =>
                    !isViewMode &&
                    handleChange({
                      target: {
                        name: "category",
                        value: value.id,
                        fullPath: value.fullPath,
                      },
                    })
                  }
                  disabled={isViewMode}
                />
              </div>

              <div>
                <Subheading className="mb-2">Brand</Subheading>
                <Combobox
                  name="brand"
                  value={formData.brand}
                  onChange={(value) =>
                    !isViewMode &&
                    handleChange({
                      target: { name: "brand", value },
                    })
                  }
                  options={brandOptions}
                  placeholder="Select brand"
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 
                   outline-1 -outline-offset-1 outline-gray-300 
                   focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                  disabled={isViewMode}
                  position="bottom"
                />
              </div>

              <div>
                <Subheading className="mb-2">Impression</Subheading>
                <Listbox
                  id="impressions"
                  name="impressions"
                  disabled={isViewMode}
                  value={formData.impressions}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "impressions", value },
                    })
                  }
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 
                   outline-1 -outline-offset-1 outline-gray-300 
                   focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {impressionsOpt.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>
              </div>

              {/* Row 2 */}
              <div>
                <Subheading className="mb-2">Sku Limit</Subheading>
                <Listbox
                  id="sku_limit"
                  name="sku_limit"
                  disabled={isViewMode}
                  value={formData.sku_limit}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "sku_limit", value },
                    })
                  }
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 
                   outline-1 -outline-offset-1 outline-gray-300 
                   focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {skuLimitOpt.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>
              </div>

              <div>
                <Subheading className="mb-2">Batch Type</Subheading>
                <Listbox
                  id="batch_type"
                  name="batch_type"
                  disabled={isViewMode}
                  value={formData.batch_type}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "batch_type", value },
                    })
                  }
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 
                   outline-1 -outline-offset-1 outline-gray-300 
                   focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {batchTypeOpt.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>
              </div>

				<div>
                <Subheading className="mb-2">Title Depth</Subheading>
                <Listbox
                  id="title_depth"
                  name="title_depth"
                  disabled={isViewMode}
                  value={formData.title_depth}
                  onChange={(value) =>
                    handleChange({
                      target: { name: "title_depth", value },
                    })
                  }
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 
                   outline-1 -outline-offset-1 outline-gray-300 
                   focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {titleDepthOpt.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>
              </div>

            </div>
          </section> 
          <Divider className="my-4" soft />
          <section className="grid gap-x-8 gap-y-6 grid-cols-1">
            <div className="space-y-1">
              <Subheading>Title Strategies</Subheading>
              <Text>Create your permutations here.</Text>
            </div>
            <Field>
              {formErrors.permutations && (
                <ErrorMessage className="mb-3">
                  {formErrors.permutations}
                </ErrorMessage>
              )}
              {isViewMode ? (
                <TitlePermutationEdit
                  onChange={handlePermutationChange}
                  optionsAI={optionsAI}
                  permutations={permutations || {}}
                  readOnly={isViewMode}
                  parentData={formData}
                />
              ) : isEditMode ? (
                <TitlePermutationEdit
                  onChange={handlePermutationChange}
                  optionsAI={optionsAI}
                  permutations={permutations || {}}
                  readOnly={isViewMode}
                  parentData={formData}
                />
              ) : (
                <TitlePermutation
                  onChange={handlePermutationChange}
                  optionsAI={optionsAI}

                  parentData={formData}
                />
              )}
            </Field>
          </section>
          <Divider className="my-4" soft />

          <section className="grid gap-x-8 gap-y-6 grid-cols-1 md:grid-cols-2">
            {/* Trigger Column */}
            <div className="space-y-1">
              <Subheading>Trigger</Subheading>
              <Text>
                These are the switch-over fields used for the test title.
              </Text>

              <Field className="mt-4">
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                  {/* Impressions Dropdown */}
                  <div className="flex-1 w-full md:w-auto">
                    <Subheading>Impressions</Subheading>
                    <Listbox
                      id="impression_count"
                      disabled={isViewMode}
                      name="impression_count"
                      value={formData.impression_count}
                      onChange={(value) =>
                        handleChange({
                          target: { name: "impression_count", value },
                        })
                      }
                      className={`w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 ${
                        formErrors.trigger
                          ? "outline-red-300"
                          : "outline-gray-300"
                      } focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6`}
                    >
                      {triggerImpOpt.map((opt) => (
                        <ListboxOption key={opt.value} value={opt.value}>
                          {opt.label}
                        </ListboxOption>
                      ))}
                    </Listbox>
                  </div>

                  {/* OR Separator */}
                  <div className="text-sm font-medium mt-2 md:mt-6">
                    <Subheading className="!text-purple-900">Or</Subheading>
                  </div>

                  {/* Days Dropdown */}
                  <div className="flex-1 w-full md:w-auto">
                    <Subheading>Days</Subheading>
                    <Listbox
                      id="days"
                      name="days"
                      disabled={isViewMode}
                      value={formData.days}
                      onChange={(value) =>
                        handleChange({ target: { name: "days", value } })
                      }
                      className={`w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 ${
                        formErrors.trigger
                          ? "outline-red-300"
                          : "outline-gray-300"
                      } focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6`}
                    >
                      {triggerDaysOpt.map((opt) => (
                        <ListboxOption key={opt.value} value={opt.value}>
                          {opt.label}
                        </ListboxOption>
                      ))}
                    </Listbox>
                  </div>
                </div>

                {/* Error row → spans whole group */}
                {formErrors.trigger && (
                  <div className="mt-2">
                    <ErrorMessage>{formErrors.trigger}</ErrorMessage>
                  </div>
                )}
              </Field>
            </div>

            {/* When to Start Column */}
            <div className="space-y-1">
              <Subheading>When to start</Subheading>
              <Text>This defines when the test title should start.</Text>
			  
			  <CheckboxField>
				  <Checkbox
						name="qcTest"
						disabled={isViewMode}
                        checked={formData.qcTest}
                        onChange={(checked) =>
                          handleChange({
                            target: { name: "qcTest", value: checked },
                          })
                        }
					  />
				  <Label>I will QC before test goes live</Label>
			  </CheckboxField>

              <div className="relative mt-3">
                <Listbox
                  id="start_type"
                  name="start_type"
                  disabled={isViewMode}
                  value={formData.start_type}
                  onChange={(value) =>
                    handleChange({ target: { name: "start_type", value } })
                  }
                  className="w-full appearance-none rounded-md py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                >
                  {startTypes.map((opt) => (
                    <ListboxOption key={opt.value} value={opt.value}>
                      {opt.label}
                    </ListboxOption>
                  ))}
                </Listbox>

                {formData.start_type === "Cycle Start After" && (
                  <input
                    type="date"
                    name="custom_date"
                    value={formData.custom_date}
                    readOnly={isViewMode}
                    onChange={handleChange}
                    min={new Date().toISOString().split("T")[0]}
                    onKeyDown={(e) => e.preventDefault()} // block keyboard editing
                    className="w-full md:w-1/2 md:absolute mt-2 md:mt-0 md:top-0 md:right-0 p-[5px] rounded-md border border-gray-300"
                  />
                )}
              </div>
            </div>
          </section>

          {!isViewMode && (
            <>
              <Divider className="my-4" soft />

              <div className="flex justify-end gap-4">
                <Button
                  type="reset"
                  onClick={() => navigate("/title-test")}
                  outline
                >
                  Cancel
                </Button>
                <Button type="submit" disabled={submitting || isViewMode}>
                  {submitting ? "Saving..." : "Save"}
                </Button>
              </div>
            </>
          )}
        </form>
        {loading && <Loader />}
      </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}
